import React from 'react';
import './Signup.css';
import {Navbar, Page} from 'framework7-react';
import Input from '../../input/Input';
import Button from '../../button/Button';
import FormTemplate from '../../templates/formTemplates/FormTemplate';
import mainAPI from 'api/MainAPI.js';
import toasts from '../../../utils/toasts';
import DropDown from "../../dropDown/DropDown";
import Textarea from "../../textarea/Textarea";
import {VERSION} from "../loginHome/LoginHome";
import TertiaryButton from "../../tertiaryButton/TertiaryButton";

const maxPrompts = 2;
export default class Signup extends FormTemplate {
	constructor(props) {
		super(props);
		this.state = {promptAttempts: 0}
	}

	submit = async () => {
		if (!this.isValid()) return;
		let formInfo = this.getValue();
		if (this.state.promptAttempts < maxPrompts && this.isResetPasswordRelated(formInfo.question_or_comment)) {
			this.setState({promptAttempts: this.state.promptAttempts + 1});
			return toasts.show('Are you trying to set/reset your password? Touch here and you can do it yourself.', 10000, true, this.passwordResetRequest)
		}
		if (this.state.promptAttempts < maxPrompts && this.isExpireLinkRelated(formInfo.question_or_comment)) {
			this.setState({promptAttempts: this.state.promptAttempts + 1});
			return toasts.show('Did the link expire in your email to signup/reset password? Touch here to get a new link.', 10000, true, this.passwordResetRequest)
		}
		if (this.state.promptAttempts < maxPrompts && this.isAccountCreationRelated(formInfo.question_or_comment)) {
			this.setState({promptAttempts: this.state.promptAttempts + 1});
			return toasts.show('Are you trying to create your account? If you have already been invited, touch here to set your password.', 10000, true, this.passwordResetRequest)
		}
		formInfo.question_or_comment += ` (LogRx App ${VERSION} ${window?.cordova ? window.cordova.platformId : 'web'})`;
		toasts.show('Thank you for contacting us. A member of our team will contact you shortly.', 3500);
		await mainAPI.contact_us.create(formInfo);
		window.f7.views.login.router.back();
	};
	onResetPasswordComplete = () => {
		window.f7.views.login.router.back();
		setTimeout(() => {
			window.f7.views.login.router.back();
		}, 700)
	};
	passwordResetRequest = () => {
		let formInfo = this.getValue();
		window.f7.views.login.router.navigate('/forgot/password', {
			props: {
				mode: 'Reset',
				email: formInfo.email,
				onComplete: this.onResetPasswordComplete,
			}
		});
	}
	isResetPasswordRelated = (message) => {
		const patterns = [
			/reset.*password/i,
			/password.*reset/i,
			/forgot.*password/i,
		];
		return patterns.some((pattern) => pattern.test(message));
	};
	isExpireLinkRelated = (message) => {
		const patterns = [
			/invite.*expired/i,
			/expired.*invite/i,
			/expired.*link/i,
			/link.*expired/i,
			/new.*link/i,
			/new.*invite/i,
		];
		return patterns.some((pattern) => pattern.test(message));
	};
	isAccountCreationRelated = (message) => {
		const patterns = [
			/create.*account/i,
			/sign\s?up/i,
			/account.*activation/i,
			/verify.*email/i,
			/need.*account/i,
			/account.*access/i,
		];
		return patterns.some((pattern) => pattern.test(message));
	};

	render() {
		return (
			<Page className="g-signup">
				<Navbar title=" " backLink="Back"></Navbar>
				<Input ref={(ref) => (this.myRefs.first_name = ref)} required iconName="icon-person" placeholder="First Name"/>
				<Input ref={(ref) => (this.myRefs.last_name = ref)} required iconName="icon-person" placeholder="Last Name"/>
				<Input
					ref={(ref) => (this.myRefs.agency_name = ref)}
					required
					iconName="icon-flag"
					placeholder="Organization Name"
				/>
				<Input ref={(ref) => (this.myRefs.email = ref)} required iconName="icon-email" placeholder="Email Address"/>
				<Textarea ref={(ref) => (this.myRefs.question_or_comment = ref)} required placeholder="Question/Comment"/>
				<DropDown
					options={{
						Sales: 'Sales',
						Support: 'Support',
					}}
					placeholder="Who would you like to contact?"
					ref={(ref) => (this.myRefs.department = ref)}
					required
				/>
				<Button color="white" bg="blue" onClick={this.submit}>
					Submit
				</Button>
				<div>
					<TertiaryButton className={'reset-password'} href="/forgot/password/">
						Reset Password
					</TertiaryButton>
				</div>
			</Page>
		);
	}
}
